import { ACTIONS } from 'actions/set-media-provider';

const initialState = {};

export default function defaultExport(state = initialState, { type, payload }) {
  const { provider, reason } = payload || {};

  switch (type) {
    case ACTIONS.SET_MEDIA_PROVIDER: {
      return {
        ...state,
        current_media_provider: provider,
        reason,
      };
    }
    case ACTIONS.CLEAR_MEDIA_PROVIDER:
      return initialState;
    default:
      return state;
  }
}
